import { useUser } from 'hooks/user/useUser'
import { useToken } from 'utils/hooks/useToken'
import { currencyFormatter } from 'utils'
import { useMemo } from 'react'
import { HeaderWalletCSS } from './HeaderWalletCSS.styled'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

import { useLvgLiveOrdersAmount } from 'hooks/games/lvg/useYourBidsOrders'
import { useNavigate } from 'react-router-dom'

export const HeaderWallet = () => {
  const navigateTo = useNavigate()
  const { tokenId, formatToken } = useToken()
  const { yoloWalletAmount, tokenAmount } = useUser('balance')
  const { liveOrdersAmount } = useLvgLiveOrdersAmount()

  const balance = useMemo(() => {
    const fiatTokenBalance = formatToken(yoloWalletAmount)

    const fiatWalletBalance = formatToken(tokenAmount)

    const availableBalance = fiatTokenBalance + fiatWalletBalance
    const portfolioBalance = fiatTokenBalance + fiatWalletBalance + liveOrdersAmount.potentialAmount

    return {
      availableBalance: currencyFormatter(availableBalance, { useLongNumber: true }),
      portfolioBalance: currencyFormatter(portfolioBalance, { useLongNumber: true }),
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [yoloWalletAmount, tokenAmount, tokenId, liveOrdersAmount?.potentialAmount])

  const showWalletInfo = () => {
    navigateTo(`/game/${CONTENT_TYPES.WALLET}`)
  }
  return (
    <HeaderWalletCSS>
      <div className='balances_wrapper' onClick={showWalletInfo}>
        <div className='balances'>
          <div className='available_balance'>
            {balance.availableBalance}
            <span
              className='info_icon hint--rounded hint--small hint--bottom-left'
              data-hint='Available&#10;balance'
            ></span>
          </div>
          <div className='net_balance'>{balance.portfolioBalance}</div>
        </div>
        <div to='/game/wallet' className='deposit_button'>
          Deposit
        </div>
      </div>
    </HeaderWalletCSS>
  )
}
